import ColyseusClient from "@/colyseusClient";
import store from "@/store";
import helper from "@/helpers";
import router from "@/router";
import Vue from "vue";
import axios from 'axios';

function initMainRoom() {
    store.state.browser = helper.browser.browserName();
    updateRoomList();
    ColyseusClient.getAvailableRooms("mainRoom")
        .then(rooms => {
            if (!rooms.length) {
                ColyseusClient.joinOrCreate("mainRoom")
                    .then(room => {
                        addMainRoomOnMessage(room);
                    })
                    .catch(e => {
                        console.error("join error", e);
                    });
            } else {
                ColyseusClient.joinById(rooms[0].roomId)
                    .then(room => {
                        addMainRoomOnMessage(room);
                    })
                    .catch(e => {
                        console.error("join error", e);
                    });
            }
        })
        .catch(e => {
            console.error(e);
        });
}

function checkReJoinAvailable() {
    let room = helper.localStorage.get("room");
    if (room) {
        reJoin(room.roomId, room.sessionId);
    }
    else {
        loader(false);
    }
}

function createBingoRoom(roomAlias) {
    loader(true);
    const { player } = store.state;
    store.state.room.myRoomAlias = roomAlias;
    ColyseusClient.create("bingoRoom", { roomAlias, player })
        .then(room => {
            loader(false);
            addStateChangeLitsener(room);
            router.replace({
                name: 'joinedRoom', params: {
                    roomId: room.id,
                    playerId: room.sessionId
                }
            });
        })
        .catch(e => {
            loader(false);
            console.error("join error", e);
        });
}

function joinBingoRoomByAlias(alias, updateMainRoom) {
    loader(true);
    axios.get(process.env.VUE_APP_SERVER_URL+'/getRoomIdFromAlias?roomAlias='+alias)
    .then(function (response) {
        var roomId = response.data.roomId;
        store.state.room.myRoomIdAlias = roomId;
        joinBingoRoom(roomId, updateMainRoom);
    }).catch(function(){
        loader(false);
    });
}

function checkIfAppOutdated(currentBuild) {
    axios.get(process.env.VUE_APP_SERVER_URL+'/getUpdateTriggerValue')
    .then(function (response) {
        if(currentBuild<response.data.value){
            store.state.appOutDated = true;
        }
    });
}

function joinBingoRoom(roomId, updateMainRoom) {
    loader(true);
    const { player } = store.state;
    ColyseusClient.joinById(roomId, { player })
        .then(room => {
            loader(false);
            addStateChangeLitsener(room, updateMainRoom);
            router.replace({
                name: 'joinedRoom', params: {
                    roomId: room.id,
                    playerId: room.sessionId
                }
            });
        })
        .catch(e => {
            loader(false);
            if(router.currentRoute.path != '/'){
                router.replace('/');
            }
            updateRoomList();
            handleRoomJoinError(e.message);
        });
}

function handleRoomJoinError(message){
    let toastMessage = 'Room Closed !';
    if(String(message).indexOf('not found')>=0 || String(message).indexOf('invalid method')>=0){
        toastMessage = 'Room not found !';
    }
    Vue.toasted.show(toastMessage, { 
        position: "top-center", 
        duration : 3000
    });
}

function reJoin(roomId, sessionId, updateMainRoom = true,rejoinRoomIdFromButton = false) {
    store.state.room.retryingConnection = true;
    ColyseusClient.reconnect(roomId, sessionId).then(room => {
        if(rejoinRoomIdFromButton && store.state.room.myRoomId != rejoinRoomIdFromButton){
            room.leave();
            return;
        }
        store.state.room.retryingConnection = false;
        addStateChangeLitsener(room, updateMainRoom, rejoinRoomIdFromButton);
    }).catch(e => {
        if(rejoinRoomIdFromButton && store.state.room.myRoomId != rejoinRoomIdFromButton){
            return;
        }
        if(e.message && e.message.indexOf('not found') < 0){
            joinBingoRoom(roomId, updateMainRoom);
        }else if(store.state.room.myRoom){
            store.state.room.retryingConnection = false;
            Vue.toasted.show("Error reconnecting", { 
                position: "top-center", 
                duration : 3000
            });
        }else{
            store.state.room.retryingConnection = false;
            Vue.toasted.show("Room not found", { 
                position: "top-center", 
                duration : 3000
            });   
            if(router.currentRoute.path != '/'){
                router.replace('/');
            }
        }
    });
}

function reTry(updateMainRoom = true) {
    const roomId = router.currentRoute.params.roomId;
    const sessionId = router.currentRoute.params.playerId;
    reJoin(roomId,sessionId,updateMainRoom,roomId);
}

function addMainRoomOnMessage(room) {
    // checkReJoinAvailable();
    store.state.room.mainRoomObject = room;
    room.onMessage(message => {
        handleMainRoomIncomingMessage(message);
    });
}

function handleMainRoomIncomingMessage(message) {
    if (message === "ROOM_UPDATE") {
        updateRoomList();
    }
}

function handleBingoRoomIncomingMessage(message) {
    switch (message.type) {
        case "POP_EMOJI":
            showPopedEmoji(message);
            break;
        case "KICKOUT":
            Vue.toasted.show("You have been kicked out from the room !", { 
                    position: "top-center", 
                    duration : 3000
            });
            leaveRoom();
            break;
        default:
            break;
    }
}

function showPopedEmoji({ emojiName, playerId }) {
    store.commit('popEmoji', { emojiName, playerId });
}

function updateRoomList() {
    if(store.state.roomListLoading)return;
    store.state.roomListLoading = true;
    ColyseusClient.getAvailableRooms("bingoRoom").then(rooms => {
        store.state.room.roomsList = rooms;
        store.state.roomListLoading = false;
    }).catch(e => {
        store.state.roomListLoading = false;
        Vue.toasted.show("Network Error", { 
            position: "top-center", 
            duration : 1000
        });
    });
}

function addStateChangeLitsener(room, updateMainRoom = true,rejoinRoomIdFromButton = false) {
    store.state.room.retryingConnection = false;
    if(rejoinRoomIdFromButton && store.state.room.myRoomId != rejoinRoomIdFromButton){
        return;
    }
    store.state.room.myRoomId = room.id;
    store.state.room.bingoRoomObject = room;
    if (updateMainRoom) {
        initiateRoomUpdate();
    }
    room.onStateChange(state => {
        store.state.room.myRoom = state.players.toJSON();
        store.state.player.id = room.sessionId;
        store.state.room.name = state.roomName;
        store.state.room.myAdminPlayer = state.currentPlayer;
        store.state.room.myRoomCurrentPlayer = state.currentPlayer;
        store.state.room.gameStarted = state.gameStarted;
        store.state.room.myRoomAdmin = state.adminPlayer;
        store.state.room.myRoomAdmin = state.adminPlayer;
        store.state.room.playerTimeout = state.playerTimeout;
        store.state.room.offlinePlayerTimeout = state.offlinePlayerTimeout;
        store.state.room.networkError = false;
    });
    room.onLeave((code) => {
        if(code == 1005){
            Vue.toasted.show("You have been kicked out from the room !", { 
                position: "top-center", 
                duration : 3000
            });
            leaveRoom();
            return;
        }
        store.state.room.networkError = true;
    });
    room.onError((code) => {
        store.state.room.networkError = true;
    });
    room.onMessage(message => {
        handleBingoRoomIncomingMessage(message);
    });

}

function playMyTurn(number) {
    // store.state.room.myRoomCurrentPlayer=null;
    const { bingoRoomObject } = store.state.room;
    bingoRoomObject.send({ type: "PLAY_MY_TURN", number });
}

function popEmoji(emojiName) {
    const { bingoRoomObject } = store.state.room;
    showPopedEmoji({ playerId: store.state.player.id, emojiName });
    bingoRoomObject.send({ type: "POP_EMOJI", emojiName });
}

function initiateRoomUpdate() {
    const { mainRoomObject } = store.state.room;
    if(!mainRoomObject){
        initMainRoom();
        return;
    }
    mainRoomObject.send("ROOM_UPDATE");
}

function startGame() {
    const { bingoRoomObject } = store.state.room;
    bingoRoomObject.send({ type: "START_GAME" });
}

function reopenRoom() {
    const { bingoRoomObject } = store.state.room;
    bingoRoomObject.send({ type: "RE_OPEN_ROOM" });
    initiateRoomUpdate();
}

function leaveRoom() {
    const { bingoRoomObject } = store.state.room;
    if(!bingoRoomObject)return;
    store.state.room.leaveRoomConfirmModal = false;
    bingoRoomObject.send({ type: "REMOVE_PLAYER" });
    bingoRoomObject.leave();
    initiateRoomUpdate();
    bingoRoomObject.removeAllListeners();
    removeRoom();
}

function loader(value = true, text = '') {
    store.state.loading = value;
    store.state.loadingText = text;
    if (!value) store.state.loadingText = '';
}

function removeRoom() {
    store.state.room.myRoom =
        store.state.room.myAdminPlayer =
        store.state.room.myRoomCurrentPlayer =
        store.state.room.gameStarted =
        store.state.room.myRoomAdmin = null;
    store.state.room.myRoomId = '';
    router.replace({ path: '/' });
}

function kickoutPlayer(playerId){
    const { bingoRoomObject } = store.state.room;
    bingoRoomObject.send({ type: "KICKOUT_PLAYER", playerId });
}

export default {
    initMainRoom,
    createBingoRoom,
    addStateChangeLitsener,
    joinBingoRoom,
    playMyTurn,
    startGame,
    reJoin,
    leaveRoom,
    initiateRoomUpdate,
    reopenRoom,
    popEmoji,
    reTry,
    kickoutPlayer,
    updateRoomList,
    joinBingoRoomByAlias,
    checkIfAppOutdated
};
